import { render, staticRenderFns } from "./NotificationSettings.vue?vue&type=template&id=26de5f28"
import script from "./NotificationSettings.vue?vue&type=script&lang=js"
export * from "./NotificationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports